import React from "react";
import {
  BOOKING_WINDOW,
  HOUR_CHOICES,
  MINUTE_CHOICES,
  fmtChoiceWords,
  fmtTimeWords,
  hourLabel,
  isOutsideWindow,
  parseTime,
  toTimeStr,
} from "../lib/bookingWindow";

const BTN =
  "py-2 text-xs font-bold rounded transition-colors disabled:opacity-30 disabled:cursor-not-allowed";
const ON = "bg-[#0F6B6B] text-[#FFFFFF]";
const OFF = "bg-[#EEE9E0] text-[#2A2623] hover:bg-[#E8E1D6]";

// Tap-to-choose start time — three columns of hours matching the Schedule
// rows, then the quarter-hour row. No native time wheel anywhere.
export default function TimeGrid({
  value,
  onChange,
  durationMin = 60,
  dateIso,
  testid = "time-grid",
  label = "Start time",
}) {
  const { hour, minute } = parseTime(value);
  const dur = Number(durationMin || 60);

  const pick = (h, m) => onChange(toTimeStr(h, m));

  return (
    <div data-testid={testid} className="space-y-2">
      <label className="tm-label">{label}</label>
      <div className="grid grid-cols-3 gap-1.5">
        {HOUR_CHOICES.map((h) => {
          const disabled = isOutsideWindow(toTimeStr(h, minute), dur);
          return (
            <button
              key={h}
              type="button"
              disabled={disabled}
              aria-pressed={h === hour}
              data-testid={`${testid}-hour-${h}`}
              onClick={() => pick(h, minute)}
              className={`${BTN} ${h === hour ? ON : OFF}`}
            >
              {hourLabel(h)}
            </button>
          );
        })}
      </div>
      <div className="grid grid-cols-4 gap-1.5">
        {MINUTE_CHOICES.map((m) => {
          const disabled = isOutsideWindow(toTimeStr(hour, m), dur);
          return (
            <button
              key={m}
              type="button"
              disabled={disabled}
              aria-pressed={m === minute}
              data-testid={`${testid}-minute-${m}`}
              onClick={() => pick(hour, m)}
              className={`${BTN} ${m === minute ? ON : OFF} text-[11px] font-mono`}
            >
              :{String(m).padStart(2, "0")}
            </button>
          );
        })}
      </div>
      <p className="text-[11px] text-[#2A2623]" data-testid={`${testid}-words`}>
        {dateIso ? fmtChoiceWords(dateIso, value) : fmtTimeWords(value)}
        <span className="text-[#6B635C]"> · {dur} min</span>
      </p>
      {isOutsideWindow(value, dur) && (
        <p className="text-[11px] text-[#7A5E18]" data-testid={`${testid}-window-warning`}>
          {BOOKING_WINDOW.message}
        </p>
      )}
    </div>
  );
}
